"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVoyageParams = void 0;
const calculator_types_1 = require("../fleet-calculator/calculator-types");
const isVoyageParams = (obj) => 
// VoyageParams stuff
(obj.emission_allowance_price === undefined ||
    obj.emission_allowance_price === null ||
    typeof obj.emission_allowance_price === "number") &&
    (obj.imo_number === undefined ||
        obj.imo_number === null ||
        typeof obj.imo_number === "number") &&
    typeof obj.ship_type === "number" &&
    (obj.draft === undefined ||
        obj.draft === null ||
        typeof obj.draft === "number") &&
    typeof obj.ballast === "boolean" &&
    typeof obj.season === "number" &&
    (obj.speed === undefined ||
        obj.speed === null ||
        typeof obj.speed === "number") &&
    typeof obj.departure_port === "string" &&
    typeof obj.departure_port_label === "string" &&
    typeof obj.destination_port === "string" &&
    typeof obj.destination_port_label === "string" &&
    Array.isArray(obj.disabled_canals) &&
    obj.disabled_canals.every((item) => typeof item === "string") &&
    Array.isArray(obj.disabled_passages) &&
    obj.disabled_passages.every((item) => typeof item === "string") &&
    // Fuels
    Array.isArray(obj.fuels) &&
    obj.comparison_fuels.every(calculator_types_1.isOriginFuelParams) &&
    Array.isArray(obj.comparison_fuels) &&
    obj.comparison_fuels.every(calculator_types_1.isAlternativeFuelParams);
exports.isVoyageParams = isVoyageParams;
